import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import classnames from 'classnames';
import { createUseStyles, Icon } from 'hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'FullModalBlank');
var _ref3 = /*#__PURE__*/React.createElement(Icon, {
  name: "close"
});
const FullModalBlank = _ref => {
  let {
    withCloseIcon,
    onRequestClose,
    contentLeft,
    contentLeftClassName,
    contentCenter,
    contentCenterClassName,
    contentRight,
    contentRightClassName,
    children,
    className,
    overlayClassName,
    headerClassName,
    closeClassName,
    isOpen,
    onAfterOpen,
    ariaHideApp = false,
    closeTimeoutMS = 500,
    shouldCloseOnEsc = true,
    shouldCloseOnOverlayClick = true
  } = _ref;
  const classes = useStyles();
  // Classes
  const rootClassNames = classnames(classes.root, className);
  const contentLeftClassNames = classnames(classes.contentLeft, contentLeftClassName);
  const contentCenterClassNames = classnames(classes.contentCenter, contentCenterClassName);
  const contentRightClassNames = classnames(classes.contentRight, contentRightClassName);
  const overlayClassNames = classnames(classes.overlay, overlayClassName);
  const headerClassNames = classnames(classes.header, headerClassName);
  const closeClassNames = classnames(classes.close, closeClassName);
  var _ref2 = /*#__PURE__*/React.createElement("div", {
    className: closeClassNames,
    onClick: onRequestClose
  }, _ref3);
  const renderClose = useMemo(() => {
    if (!withCloseIcon || !onRequestClose) return null;
    return _ref2;
  }, [closeClassNames, onRequestClose, withCloseIcon]);
  const renderLeft = useMemo(() => {
    if (!contentLeft) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: contentLeftClassNames
    }, contentLeft());
  }, [contentLeft, contentLeftClassNames]);
  const renderCenter = useMemo(() => {
    if (!contentCenter) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: contentCenterClassNames
    }, contentCenter());
  }, [contentCenter, contentCenterClassNames]);
  const renderRight = useMemo(() => {
    return /*#__PURE__*/React.createElement("div", {
      className: contentRightClassNames
    }, contentRight(), renderClose);
  }, [contentRight, contentRightClassNames, renderClose]);
  return /*#__PURE__*/React.createElement(Modal, {
    ariaHideApp: ariaHideApp,
    className: rootClassNames,
    overlayClassName: overlayClassNames,
    closeTimeoutMS: closeTimeoutMS,
    isOpen: isOpen,
    onAfterOpen: onAfterOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnEsc: shouldCloseOnEsc,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
  }, /*#__PURE__*/React.createElement("div", {
    className: headerClassNames
  }, renderLeft, renderCenter, renderRight), children);
};
process.env.NODE_ENV !== "production" ? FullModalBlank.propTypes = {
  children: PropTypes.any,
  ariaHideApp: PropTypes.bool,
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  headerClass: PropTypes.string,
  closeTimeoutMS: PropTypes.number,
  isOpen: PropTypes.bool,
  onAfterOpen: PropTypes.func,
  onRequestClose: PropTypes.func,
  shouldCloseOnEsc: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
  withCloseIcon: PropTypes.bool,
  contentLeft: PropTypes.func,
  contentLeftClassName: PropTypes.string,
  contentCenter: PropTypes.func,
  contentCenterClassName: PropTypes.string,
  contentRight: PropTypes.func,
  contentRightClassName: PropTypes.string,
  closeClassName: PropTypes.string
} : void 0;
export default /*#__PURE__*/memo(FullModalBlank);